import { render, staticRenderFns } from "./device-bar.vue?vue&type=template&id=31596c16&scoped=true"
import script from "./device-bar.vue?vue&type=script&lang=ts"
export * from "./device-bar.vue?vue&type=script&lang=ts"
import style0 from "./device-bar.vue?vue&type=style&index=0&id=31596c16&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31596c16",
  null
  
)

export default component.exports